import { OwnEvent } from './../interfaces/own-event';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConnectionStatus, NetworkService } from './network.service';
import { IterableSet } from '../realtime/operators';
import { webSocket } from 'rxjs/webSocket';
import { debounceTime, delayWhen, distinctUntilChanged, filter, map, retryWhen, switchMap, tap } from 'rxjs/operators';
import { StorageService } from './storage.service';
import { ChunkKind } from '../realtime/interfaces/chunk-kind';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(
    private http: HttpClient,
    public network: NetworkService,
    private storage: StorageService
  ) { }

  getAllEvents(companyId: string): Observable<any> {
    return this.http.get(`${environment.url}/bucket/${environment.buckets.events}/data?filter={"company":"${companyId}", "start_date": {"$gte": "Date(${new Date().toISOString()})"}}&relation=location&relation=service&relation=schedules`)
  }

  notifyCustomerBookingSuccess(email, event, booking): Observable<any> {
    return this.http.post<any>(`${environment.url}/fn-execute/notifyCustomer`, {
      event,
      email,
      booking
    })
  }

  notifyCustomersChangedEvent(old_event, new_event, attendees): Observable<any> {

    return this.http.post<any>(`${environment.url}/fn-execute/notifyCustomersChangedEvent`, {
      old_event,
      new_event,
      attendees
    })
  }
  notifyCustomerDeletedBooking(customer, event): Observable<any> {
    return this.http.post<any>(`${environment.url}/fn-execute/notifyCustomerDeletedBooking`, {
      customer,
      event
    })
  }

  notifyCustomersCancelledEvent(attendees, event): Observable<any> {
    return this.http.post<any>(`${environment.url}/fn-execute/notifyCustomersCancelledEvent`, {
      attendees,
      event
    })
  }

  editEvent(event) {
    return this.http.put<OwnEvent>(`${environment.url}/bucket/${environment.buckets.events}/data/${event._id}`, this.flatEvent(event))
  }

  addEvent(data) {
    return this.http.post<OwnEvent>(
      `${environment.url}/bucket/${environment.buckets.events}/data`,
      data)

  }
  deleteEvent(id: string) {
    return this.http.delete<OwnEvent>(
      `${environment.url}/bucket/${environment.buckets.events}/data/${id}`,
    )

  }

  flatEvent(event: OwnEvent) {
    if (event.location) {

      if (typeof event.location !== "string")
        event.location = event.location._id;
    }
    if (event.company) {

      if (typeof event.company !== "string")
        event.company = event.company._id;
    }

    if (event.service) {
      if (typeof event.service !== "string")
        event.service = event.service._id;
    }

    console.log('FlatEvent:  ', event);
    return event;
  }


  wsEvents(companyId: string): Observable<OwnEvent[]> {
    return this.network.onNetworkChange().pipe(
      switchMap((status: ConnectionStatus) => {

        if (status === ConnectionStatus.Online) {
          const url = new URL(
            `${environment.ws_url}/bucket/${environment.buckets.events}/data`
          );
          url.searchParams.set('filter', JSON.stringify({ company: companyId }));
          url.searchParams.set('Authorization', `APIKEY ${environment.apikey}`);

          return this.getWsObs<OwnEvent>(url.toString()).pipe(
            map(appointments => {

              // appointments.forEach(appointment => {
              //   appointment.end_date = moment
              //     .utc(appointment.end_date, 'YYYY-MM-DD HH:mm:ss')
              //     .local()
              //     .toDate();
              //   appointment.start_date = moment
              //     .utc(appointment.start_date, 'YYYY-MM-DD HH:mm:ss')
              //     .local()
              //     .toDate();
              // });

              return appointments;
            }),
            tap(appointments => this.storage.set(environment.storage.allSchedules, appointments))
          );
        } else {
          return this.storage.get(environment.storage.allSchedules);
        }
      })
    );
  }/*

  // TODO: von Stefan holen
  wsSchedules(companyId: string): Observable<OwnEvent[]> {
    return this.network.onNetworkChange().pipe(
      switchMap((status: ConnectionStatus) => {

        if (status === ConnectionStatus.Online) {
          const url = new URL(
            `${environment.ws_url}/bucket/${environment.buckets.bookings}/data`
          );
          url.searchParams.set('filter', JSON.stringify({ company: companyId }));
          url.searchParams.set('Authorization', `APIKEY ${environment.apikey}`);

          return this.getWsObs<OwnEvent>(url.toString()).pipe(
            map(appointments => {

              // appointments.forEach(appointment => {
              //   appointment.end_date = moment
              //     .utc(appointment.end_date, 'YYYY-MM-DD HH:mm:ss')
              //     .local()
              //     .toDate();
              //   appointment.start_date = moment
              //     .utc(appointment.start_date, 'YYYY-MM-DD HH:mm:ss')
              //     .local()
              //     .toDate();
              // });

              return appointments;
            }),
            tap(appointments => this.storage.set('allSchedules', appointments))
          );
        } else {
          return this.storage.get('allSchedules');
        }
      })
    );
  }*/


  getWsObs<T>(url: string, sort: object = {}) {
    //IterableSet causes closing of editor because of it, frequently the appointments are reloaded and scheduler new initialized
    const data = new IterableSet<T>();
    return webSocket<any>(url).pipe(
      tap(chunk => {
        switch (chunk.kind) {
          case ChunkKind.Initial:
          case ChunkKind.Insert:
          case ChunkKind.Replace:
          case ChunkKind.Update:
            data.set(chunk.document._id, chunk.document);
            break;
          case ChunkKind.Expunge:
          case ChunkKind.Delete:
            data.delete(chunk.document._id);
            break;
          case ChunkKind.Order:
            data.order(chunk.sequence);
            break;
        }
      }),
      delayWhen(chunk => {
        if (sort && chunk.kind == ChunkKind.Insert) {
          return timer(2);
        }
        return of(null);
      }),
      debounceTime(1),
      map(() => Array.from(data)),
      retryWhen(errors => errors.pipe(filter(error => error.code === 1006))),
      distinctUntilChanged((x, y) => {

        return x.length === 0 && y.length === 0;
      })
    );
  }

}
